export const issueSubCategorySelector = state => state.entities.issueSubCategories;
